import { ChevronLeftV2 } from 'src/shared/design-system/Icon';
import { Clickable } from 'src/shared/design-system/Utilities';
import styled from 'styled-components';
import { Border, Colors, Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div<{ showOnMobile: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: none;
  margin: 0 ${Spacing.QUARTER};
  ${Mixins.Shape.square(Spacing.SINGLE_HALF)}

  ${({ showOnMobile }) =>
    showOnMobile
      ? Mixins.Media.maxWidthSmall(`
        display: block;
      `)
      : ``}
`;

export const Button = styled(Clickable)`
  border: ${Border.Base} ${Colors.GRAY_DARK_20};
  padding: ${Spacing.EIGHTH};
  ${Mixins.Flex.center()}
  ${Mixins.Shape.circle(Spacing.SINGLE_HALF)}
`;

export const Icon = ChevronLeftV2;
